export default __webpack_public_path__ + "static/media/next.f833c31d.svg";